import React from 'react';
import { Form, Row, Col, Input, Button, message, Checkbox, Select, } from 'antd';
import { UserOutlined, LockOutlined, CheckCircleOutlined, PhoneOutlined, IdcardOutlined } from '@ant-design/icons';
import ckg from '../../assets/images/ckg.png';
import pclogo from '../../assets/images/pclogo.png';
import face from '../../assets/images/face.png';
import wrong from '../../assets/images/wrong.png';
import { _login, _sendsms, _updatepwd, _getinfobyprovidermerchantid, _checksmscode, _getCountryCode, _prepareActivationLegalConfirmation } from '../../utils/api';
import { connect } from 'react-redux';
import * as actions from '../../store/Action';
import { LEGAL_CONFIRMATION_LOGIN_PARAMS } from '../../utils/legal-confirmation';
import './index.scss'
import LegalConfirmationModal from '../LegalConfirmation';

const mapDispatchToProps = (dispatch) => {
  return { 
    set: (contacter) => dispatch(actions.SET_NAME({name: contacter}))
  }
}
const mapStateToProps = (state) => {
  return {...state}
}

const { Option } = Select;

const certificateTypeList = [
    {name: '大陆身份证', id: 1},
    {name: '港澳居民来往内地通行证', id: 516},
    {name: '台湾居民来往内地通行证', id: 511},
    {name: '外国人永久居留证', id: 553},
];

const companyCharacter = 1;
const collegeCharacter = 2;
const personCharacter = 3;
const firstStep = 1;

class Authentication extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            supplierType: 1,                    // 供应商性质  个人 1  企业高校 2
            agreement: 0,                       // 是否勾选同意
            send: false,
            step: 0,                            // 默认步骤一
            checkcode: '',                      // 验证码
            loginame: '',                       // 新账号
            oldloginame: '',                    // 旧账号
            name: '',                           // 姓名
            idcard: '',                         // 身份证
            newpwd: '',                         // 密码
            newpwd2: '',                        // 二次确认密码
            pwdload: false,                     // 激活账号btn loading
            providermerchantid: '',             // 供应商id
            pageLoad: false,                    // 页面loading
            codetime: 0,
            steploading: false,
            checkDisable: false,
            disableLoginame: false,             // 默认手机号可改
            certificateType: 1,                 // 证件类型， 默认大陆身份证
            countryCodeList: [],
            countryCode: null,                    // 选择国家code
            getCodeLock: false,
            legalModalVisible: false,
            legalTicket: '',
            legalAgreements: [],
            legalPageTitle: '',
            legalPageCopy: '',
        };
    };

    componentDidMount = () => {
        this.init();
        this.getCountryCode();
    };

    getCountryCode = () => {
        _getCountryCode({}).then(res => {
            if (res.code === 200) {
                this.setState({ countryCodeList: res.data, });
            } else {
              message.error(res.msg);
            }
        })
    };

    /** 页面初始化 */
    init = () => {
        let id = this.getParam('providermerchantid');
        this.setState({ providermerchantid: id });
        /** 获取供应商信息 */
        this.setState({ pageLoad: true });
        _getinfobyprovidermerchantid({providermerchantid: id}).then(res => {
            this.setState({ pageLoad: false });
            if (res.code === 200) {
                const reg = /^1[3456789]\d{9}$/;
                this.setState({ 
                    oldloginame: res.data.loginame, 
                    supplierType: res.data.character === personCharacter ? companyCharacter : collegeCharacter,
                    name: res.data['id_card_name'], 
                    step: firstStep, 
                }, () => {
                    if (reg.test(res.data.loginame)) {
                        this.setState({ 
                            loginame: res.data.loginame, 
                            disableLoginame: true,
                        });
                    }
                })
            } else {
              message.error(res.msg);
            }
        })
    };

    /** 获取页面参数 */
    getParam=(key)=> {
        let param = [];
        let url =this.props.location.search;
        url = url.slice(1).split("&");
        for (let i of url) {
            let newItem = i.split("=");
            param[newItem[0]] = newItem.length === 1 ? "" : decodeURIComponent(newItem[1]);
        }
        return param[key];
    };

    /** 验证码时间 */
    codeTimeout = () => {
        this.setState({ codetime: 60 }, () => {
            let ti = this.state.codetime;
            this.intervalId = setInterval(() => {
                ti--;
                this.setState({ codetime: ti }, () => {
                    if (this.state.codetime<0) {
                        this.setState({ codetime: 0, getCodeLock: false });
                        clearInterval(this.intervalId);                // 清空句柄，暂停计时
                        this.intervalId = null;
                    }
                });
            }, 1000);
        });
    };

    /** 点击下一步 */
    accountStep = () => {
        const { supplierType, loginame, oldloginame, name, idcard, checkcode, countryCode, certificateType } = this.state;
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (supplierType === 1 && !name) {
            message.warn('请填写供应商姓名');
            return;
        };
        if (supplierType === 1 && certificateType === 553 && !countryCode) {
            message.warn('请选择国籍');
            return;
        }
        if (supplierType === 1 && !idcard) {
            message.warn('请输入供应商证件号码');
            return;
        };
        if (!reg.test(loginame)) {
            message.warn('请输入正确的手机号');
            return;
        };
        if (!checkcode) {
            message.warn('请输入验证码');
            return;
        };
        let params = { checkcode, loginame, oldloginame };
        if (supplierType === 1) {
            params.idcard = idcard;
            params.name = name;
            params.idtype = certificateType;
        };
        if (supplierType === 1 && certificateType === 553) {
            params.nation = countryCode;
        }
        this.setState({ steploading: true });
        _checksmscode(params).then(res => {
            this.setState({ steploading: false });
            if (res.code === 200) {
                this.setState({ step: 2 });
            } else {
                message.error(res.msg);
            }
        })
    };

    /** 获取验证码 */
    getSmsCode = () => {
        const { loginame, oldloginame, getCodeLock } = this.state;
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(loginame)) {
            message.warn('请输入正确的手机号');
            return;
        };
        if (getCodeLock) {
            return;
        };
        let data = { loginame, oldloginame };
        this.sendcode(data);
    };

    sendcode = data => {
        this.setState({ getCodeLock: true });
        _sendsms(data).then(res => {
            this.codeTimeout();
            if (res.code !== 200) {
                message.error(res.msg);
            }
        })
    };

    /** 修改密码，激活账号 */
    updatepassword = () => {
        const {
            newpwd,
            newpwd2,
            providermerchantid,
            loginame,
            checkcode,
            oldloginame,
            agreement,
            legalTicket,
        } = this.state;
        if (!newpwd) {
          message.error('请填写密码');
          return;
        };
        if (!this.passwordLength(newpwd)) {
            message.error('密码长度8~16位数');
            return;
        };
        if (!this.passwordStr(newpwd)) {
            message.error('数字、大小写字母及特殊字符至少两种');
            return;
        };
        if (newpwd !== newpwd2) {
          message.error('两次密码输入不一致');
          return;
        };
        if (!agreement || !legalTicket) {
            message.error('请先阅读并确认当前有效的全部协议与规则');
            return;
        }
        const params = {
            newpwd,
            newpwd2,
            providermerchantid,
            loginame,
            checkcode,
            oldloginame,
            temporary_login_ticket: legalTicket,
            agreed: true,
            scrolled_to_bottom: true,
        };
        const loginData = { loginame, loginpwd: newpwd, ...LEGAL_CONFIRMATION_LOGIN_PARAMS };
        this.setState({ pwdload: true });
        _updatepwd(params).then(res => {
          this.setState({ pwdload: false });
            if (res.code === 200) {
                _login(loginData).then(res => {
                    if (res && res.code === 200) {
                        localStorage.setItem('s_provider_merchantid', res.data.providermerchantid);
                        localStorage.setItem('loginame', loginame);
                        localStorage.setItem('CRM_ACCOUNT_ID', res.data['crm_account_id'] || '');
                        localStorage.setItem('CRM_ACCOUNT_NAME', res.data['crm_account_name'] || '');
                        this.props.set(res.data.contacter || '');
                        const { history } = this.props;
                        history.push({
                            pathname: res.data.default_redirect || '/home',
                        });
                    } else if (res && res.code === 202) {
                        message.error('激活确认状态已变化，请退出后重新登录确认');
                    } else {
                        message.error((res && res.msg) || '请求错误，请稍后重试');
                    }
                }).catch(() => {
                    message.error('登录失败，请重新登录');
                });
            } else {
                message.error((res && res.msg) || '请求错误，请稍后重试');
            }
        }).catch(() => {
            this.setState({ pwdload: false });
            message.error('激活失败，请稍后重试');
        })
    };

    /** 短信和身份验证通过后，读取当前全部规则。此时只准备票据，不写确认流水。 */
    handleActivationLegalCheckboxChange = event => {
        if (!event.target.checked) {
            this.setState({ agreement: 0, legalTicket: '' });
            return;
        }
        const { loginame, providermerchantid } = this.state;
        this.setState({ checkDisable: true });
        _prepareActivationLegalConfirmation({ loginame, providermerchantid }).then(res => {
            this.setState({ checkDisable: false });
            if (!res || res.code !== 200) {
                message.error((res && res.msg) || '规则加载失败，请重新完成身份验证');
                return;
            }
            this.setState({
                legalModalVisible: true,
                legalTicket: res.data.temporary_login_ticket,
                legalAgreements: res.data.agreements || [],
                legalPageTitle: res.data.page_title || '',
                legalPageCopy: res.data.page_copy || '',
            });
        }).catch(() => {
            this.setState({ checkDisable: false });
            message.error('规则加载失败，请稍后重试');
        });
    };

    confirmActivationLegal = () => {
        this.setState({
            agreement: 1,
            legalModalVisible: false,
        });
    };

    cancelActivationLegal = () => {
        this.setState({
            agreement: 0,
            legalModalVisible: false,
            legalTicket: '',
            legalAgreements: [],
        });
    };

    /** 密码长度校验 */
    passwordLength = str => {
        if (str && str.length >= 8 && str.length <= 16) return true;
        else return false;
    };

    /** 密码字符校验 */
    passwordStr = str => {
        let preg = /^(?!.*[^A-Za-z0-9#?!@$%^&*-.]$)(?![a-z]*$)(?![A-Z]*$)(?![0-9]*$)(?![#?!@$%^&*-.]*$).{8,64}$/;
        return preg.test(str);
    };

    render() {
        const { supplierType, agreement, send, step, newpwd, newpwd2, pwdload, codetime, loginame, idcard, name, checkcode, steploading, checkDisable,
        disableLoginame, certificateType, countryCodeList, countryCode } = this.state;
        return (
            <Row className="authentication">
                <Col lg={13} xs={0} className="logo">
                    <img src={pclogo} alt="科学指南针" />
                    <img src={ckg} alt="供应商管理平台" />
                    <div>
                        <p>—— 科学指南针·科研服务领导者·供应商管理平台 ——</p>
                        <p>服务热线：400-831-0631</p>
                    </div>
                </Col>
                <Col lg={11} xs={24} className="form">
                    {   
                        step === 1 ? 
                        <div className={supplierType === 1 ? "rStyle person-supplier" : "rStyle"}>
                            <h3 style={{fontSize: 22}}>欢迎来到科学指南针供应商管理平台</h3>
                            <p className={ supplierType === 1 ? "account-person" : "account-alert"}>请按照以下步骤，激活账号</p>
                            {
                                supplierType === 1 &&
                                <>
                                    <Input prefix={<UserOutlined />} style={{marginTop: 30}} value={name} placeholder="姓名" size="large" onChange={e => this.setState({ name: e.target.value })} />
                                    <Select
                                        style={{marginTop: 42, width: '100%'}}
                                        value={certificateType}
                                        onChange={value => { this.setState({ certificateType: value }) }} 
                                    >
                                        {
                                            certificateTypeList.map(item => (
                                                <Option key={item.id} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                    {
                                        certificateType === 553 &&
                                        <Select
                                            showSearch
                                            style={{marginTop: 42, width: '100%'}}
                                            placeholder="请选择国籍"
                                            value={countryCode}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            allowClear
                                            onChange={value => { this.setState({ countryCode: value }) }} 
                                        >
                                            {
                                                countryCodeList.map(country => (
                                                    <Option key={country.code} value={country.code}>{country.country}</Option>
                                                ))
                                            }
                                        </Select>
                                    }
                                    <Input prefix={<IdcardOutlined />} style={{marginTop: 26}} value={idcard} placeholder="请输入证件号码" size="large" onChange={e => this.setState({  idcard : e.target.value })} />
                                </>
                            }
                            <Input prefix={<PhoneOutlined />} style={{marginTop: supplierType === 1 ? 26 : 72}} disabled={disableLoginame} value={loginame} placeholder="请输入手机号" size="large" onChange={e => this.setState({ loginame: e.target.value })} />
                            <Row>
                                <Col span={18}>
                                    <Input prefix={<CheckCircleOutlined />} style={{marginTop: 26}} value={checkcode} placeholder="请输入验证码" onChange={e => this.setState({ checkcode: e.target.value })} size="large"></Input>
                                </Col>
                                <Col  span={1} style={{borderBottom: '1px solid #d9d9d9'}}>
                                    <div style={{height: 20, width: 2, backgroundColor: 'rgba(0,0,0,0.65)', marginTop: 32}}></div>
                                </Col>
                                <Col span={5} className={send ? 'send-code discode' : 'send-code'}>
                                    <Button type="link" loading={codetime>0} onClick={this.getSmsCode}>{codetime > 0 ? `重发${codetime}S` : "发送验证码"}</Button>
                                </Col>
                            </Row>
                            <Button className="authentication-next-button" type="primary" block size="large" loading={steploading} onClick={this.accountStep}>下一步</Button>
                        </div>
                        :
                        <div className="rStyle">
                            <h3 style={{fontSize: 22}}>欢迎来到科学指南针供应商管理平台</h3>
                            <p className={ supplierType === 1 ? "account-person" : "account-alert"}>请按照以下步骤，激活账号</p>
                            <Input.Password prefix={<LockOutlined />} value={newpwd} style={{marginTop: 72}} onChange={e => this.setState({ newpwd: e.target.value })} placeholder="请输入新密码" size="large" />
                            <Input.Password prefix={<LockOutlined />} value={newpwd2} style={{marginTop: 26}} onChange={e => this.setState({ newpwd2: e.target.value })} placeholder="再次确认登录密码" size="large" />
                            <Form>
                            <Form.Item label=" " colon={false}>
                                <div className="flexRow passwordAlert">
                                    {
                                        this.passwordLength(newpwd) && <img src={face} alt="" />
                                    }
                                    {
                                        !this.passwordLength(newpwd) && <img src={wrong} alt="" />
                                    }
                                    <span className={this.passwordLength(newpwd) ? 'alerttext meet' : 'alerttext nomeet'}>密码长度8~16位数</span>
                                </div>
                                <div className="flexRow mt16 passwordAlert">
                                    {
                                        this.passwordStr(newpwd) && <img src={face} alt="" />
                                    }
                                    {
                                        !this.passwordStr(newpwd) && <img src={wrong} alt="" />
                                    }
                                    <span className={this.passwordStr(newpwd) ? 'meet alerttext' : 'nomeet alerttext'}>数字、大小写字母及特殊字符至少两种</span>
                                </div>
                                        </Form.Item>
                            </Form>
                            <div className="agree-protocol activation-legal-confirmation">
                                <Checkbox className="activation-legal-checkbox" checked={agreement === 1} disabled={checkDisable} onChange={this.handleActivationLegalCheckboxChange}></Checkbox>
                                <span className="agreeText">我已完整阅读、理解并同意遵守供应商管理平台《供应商合作协议》《测试服务供应商规范细则》《供应商管理平台申诉规则》《供应商隐私政策》及其他平台规则。</span>
                            </div>
                            <Button className="activation-confirm-button" type="primary" block size="large" loading={pwdload} onClick={this.updatepassword} disabled={!newpwd || !newpwd2 || agreement === 0}>激活账号</Button>
                        </div>
                    }
                </Col>
                <LegalConfirmationModal
                    visible={this.state.legalModalVisible}
                    agreements={this.state.legalAgreements}
                    pageTitle={this.state.legalPageTitle}
                    pageCopy={this.state.legalPageCopy}
                    onCancel={this.cancelActivationLegal}
                    onConfirm={this.confirmActivationLegal}
                />
            </Row>
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Authentication);
